<div class="audit-finding-linked-audit-info">
    @if (linkInfo) {
        <div class="detail-page-card">
            <div class="detail-page-card-title">
                {{ "auditInfo.linkedAuditTitle" | t }}
            </div>
            <div class="detail-page-card-body padded form-group-styling row">
                <div class="form-group col-6">
                    <label class="form-label">{{ "auditInfo.audit" | t }}</label>
                    <div class="input-group">
                        <input
                            type="text"
                            value="{{ +linkInfo.identifier }} - {{ linkInfo.auditName }}"
                            class="form-control form-control-sm"
                            readonly
                        />
                        <label class="input-group-text action-button" (click)="openAudit()">
                            <i class="fas fa-external-link-alt"></i>
                        </label>
                    </div>
                </div>

                <div class="col-6">
                    @if (tableConfig) {
                        <generic-list-manager [config]="tableConfig"></generic-list-manager>
                    }
                </div>
            </div>
        </div>
    }
</div>
